import PropTypes from 'prop-types';
import React from 'react';

function Voicemail(props) {
  const { fill } = props;
  return (
    <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.6875 12C1.6875 12.5417 1.7942 13.0781 2.0015 13.5786C2.2088 14.079 2.51264 14.5338 2.89568 14.9168C3.27873 15.2999 3.73346 15.6037 4.23393 15.811C4.7344 16.0183 5.2708 16.125 5.8125 16.125C6.3542 16.125 6.8906 16.0183 7.39107 15.811C7.89154 15.6037 8.34627 15.2999 8.72932 14.9168C9.11236 14.5338 9.4162 14.079 9.6235 13.5786C9.8308 13.0781 9.9375 12.5417 9.9375 12C9.9375 11.4583 9.8308 10.9219 9.6235 10.4214C9.4162 9.92096 9.11236 9.46623 8.72932 9.08318C8.34627 8.70014 7.89154 8.3963 7.39107 8.189C6.8906 7.9817 6.3542 7.875 5.8125 7.875C5.2708 7.875 4.7344 7.9817 4.23393 8.189C3.73346 8.3963 3.27873 8.70014 2.89568 9.08318C2.51264 9.46623 2.2088 9.92096 2.0015 10.4214C1.7942 10.9219 1.6875 11.4583 1.6875 12Z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M14.0625 12C14.0625 12.5417 14.1692 13.0781 14.3765 13.5786C14.5838 14.079 14.8876 14.5338 15.2707 14.9168C15.6537 15.2999 16.1085 15.6037 16.6089 15.811C17.1094 16.0183 17.6458 16.125 18.1875 16.125C18.7292 16.125 19.2656 16.0183 19.7661 15.811C20.2665 15.6037 20.7213 15.2999 21.1043 14.9168C21.4874 14.5338 21.7912 14.079 21.9985 13.5786C22.2058 13.0781 22.3125 12.5417 22.3125 12C22.3125 11.4583 22.2058 10.9219 21.9985 10.4214C21.7912 9.92096 21.4874 9.46623 21.1043 9.08318C20.7213 8.70014 20.2665 8.3963 19.7661 8.189C19.2656 7.9817 18.7292 7.875 18.1875 7.875C17.6458 7.875 17.1094 7.9817 16.6089 8.189C16.1085 8.3963 15.6537 8.70014 15.2707 9.08318C14.8876 9.46623 14.5838 9.92096 14.3765 10.4214C14.1692 10.9219 14.0625 11.4583 14.0625 12Z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path d="M5.8125 16.125H18.1875" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
    </svg>
  );
}

Voicemail.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Voicemail;
